<template>
  <div class="custom-payment-button-wrapper">
    <!-- 按钮始终显示；点击建会话期间的 loading 由 pay-popup 统一全屏遮罩处理 -->
    <div class="custom-button" @click="handleClick">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface SdkState {
  loading: boolean
  loaded: boolean
  error: any
}

interface Props {
  sdkKey: string
  isActive?: boolean
  icon?: string
  label?: string
  sdkState: SdkState
  forceSkipSdk?: boolean  // 强制跳过 SDK，直接降级
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false,
  icon: '',
  label: '',
  forceSkipSdk: false
})

const emit = defineEmits<{
  click: []
  'open-fullscreen': []
  fallback: []
}>()

const handleClick = () => {
  emit('click')

  // 强制跳过 SDK，直接降级
  if (props.forceSkipSdk) {
    emit('fallback')
    return
  }

  if (props.sdkState.loading) {
    // SDK 正在加载中，忽略点击
    return
  }

  if (props.sdkState.loaded) {
    // SDK 已加载，打开全屏页面
    emit('open-fullscreen')
  } else {
    // SDK 未加载或加载失败，降级跳转收银台
    emit('fallback')
  }
}
</script>

<style scoped lang="scss">
.custom-payment-button-wrapper {
  width: 100%;

  .custom-button {
    width: 100%;
    cursor: pointer;
  }
}
</style>
